import type { OfferDto } from "@intelligems/ig-types";

export function getShippingThresholdByOffer(offer: OfferDto) {
  const tiers = offer.tiers ?? [];
  const tier = tiers.find((t) => t.isFreeShipping);
  return tier?.minimumUnits;
}
